import { MibeModel } from './mibemodel.model';

export class MetaData implements MibeModel {
  id: number;
  keyword: string;

  /**
   * Create a MetaData.
   * @param {any} json - The JSON object with which to construct our MetaData.
   */
  constructor(json:any) {
    this.loadWithJSON(json);
  }
  /**
   * Load a MetaData.
   * @param {any} json - The JSON object with which to load our MetaData.
   */
  loadWithJSON(json: any) {
    if (!json) {
      return;
    }
    this.id = json.id;
    this.keyword = json.keyword;
  }
  /**
   * Returns a JSON representation of our MetaData
   * @return {any} - The JSON representation of our MetaData
   */
  toJSON() {
    var json: any = {
      'id': this.id,
      'keyword': this.keyword
    };
    return json;
  }
}
